import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhatIsIncluded() {
  const items = ['Vas a saber exactamente qué decirle a Dios cada día, sin dudas ni bloqueos', 'Sentirás más paz y tranquilidad incluso en momentos difíciles', 'Crearás el hábito de orar de forma simple y constante', 'Tendrás una conexión más cercana y real con Dios desde el primer día', 'Dejarás de postergar tu vida espiritual por no saber cómo empezar', 'Solo necesitas 2 minutos al día para sentir el cambio'];
  return <section className="py-20 px-6 bg-white" data-id="element-233">
      <div className="max-w-6xl mx-auto" data-id="element-234">
        <div className="text-center mb-16" data-id="element-235">
          <h2 className="font-fredoka text-3xl md:text-5xl text-charcoal mb-4" data-id="element-236">
            Esto es lo que vas a empezar a sentir desde el primer día
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-237">
            No es solo leer oraciones… es transformar tu conexión con Dios
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-238">
          <div className="w-full md:w-1/2" data-id="element-239">
            <div className="bg-cream rounded-3xl p-8 shadow-sm border border-orange-100" data-id="element-240">
              <ul className="space-y-6" data-id="element-241">
                {items.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-242">
                    <CheckCircle2 className="w-7 h-7 text-sage-green flex-shrink-0 mt-0.5" data-id="element-243" />
                    <span className="text-lg text-charcoal font-bold" data-id="element-244">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-245">
            <img src="https://cdn.magicpatterns.com/uploads/3ecLQfrCs6nEqnbtWPVMrk/Image_fx_(13).png" alt="365 Oraciones Poderosas" className="w-full h-auto rounded-3xl shadow-xl" data-id="element-246" />
          </div>
        </div>
      </div>
    </section>;
}